<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import './store';
export default {};
</script>
<style lang="less" scoped></style>
